module.exports = __webpack_public_path__ + "img/avt0.dd0fe52d.317734f4.png";